export const runIdle = (cb: () => void) => {
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(cb)
  } else {
    // Safari fallback — безопасная задержка
    setTimeout(cb, 100)
  }
}
